<template>
  <div class="sidebar">
    <!-- <div class="sidebar-panel">
      <img class="logo" src="@/assets/icons/logo.svg" />
      <img class="user" src="@/assets/icons/user.svg" />
    </div> -->
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'Sidebar'
}
</script>

<style scoped >
  .sidebar {
    border-right: 1px solid var(--grey-230);
  }
  .sidebar-panel {
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    justify-content: space-between;
    background: var(--second-base);
  }
  .logo,
  .user {
    margin: 16px;
  }
</style>
